module.exports = {
  platform: 'voice',
  name: 'Enter',
  node: 'enter',
  bg: '#FFFFFF',
  note: ''
}
